// extracted by mini-css-extract-plugin
export var csatScore = "_la-5";
export var header = "_la-1";
export var panelWrapper = "_la-2";
export var postPreview = "_la-3";
export var rightContent = "_la-0";
export var wrappingText = "_la-4";